import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "about",
  class: "py-12 about-section bg-grey-darken-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_chip_group = _resolveComponent("v-chip-group")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_v_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, { align: "center" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              md: "6"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_img, {
                  src: _ctx.aboutImage,
                  height: "500",
                  class: "rounded-lg elevation-3"
                }, null, 8, ["src"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              md: "6"
            }, {
              default: _withCtx(() => [
                _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "text-h3 font-weight-bold mb-4" }, "ABOUT ME", -1)),
                _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-h6 font-weight-light mb-4" }, " Hi, I'm Alex Morgan, a professional photographer with over 10 years of experience capturing special moments. ", -1)),
                _cache[2] || (_cache[2] = _createElementVNode("p", { class: "mb-4" }, " My passion is to tell stories through my lens, creating timeless images that reflect the beauty and emotion of every moment. I specialize in portrait, wedding, and commercial photography. ", -1)),
                _createVNode(_component_v_chip_group, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skills, (skill) => {
                      return (_openBlock(), _createBlock(_component_v_chip, {
                        key: skill,
                        color: "primary",
                        class: "ma-1"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(skill), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}